export enum ModuleTokens {
  Name = 'websockets'
}
